import React, { useEffect, useState, useRef } from "react";
import { createPortal } from 'react-dom';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import LnchStrtApi from "Apis/LnchStrtApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import GameLnchMdalUi from "Utils/GameLnchMdalUi";
import LoginModal from 'Views/Login/LoginModal';
import GameSvcLinkApi from "Apis/GameSvcLinkApi";
import MembNrmlLogoutApi from 'Apis/MembNrmlLogoutApi';
import GlitchImage from "Utils/GlitchImage";
import"Assets/css/GameSubPage.css";
import { log } from "console";
import ApiResultModal from "Components/ApiResultModal";
import {isMobile} from "react-device-detect";

const MUSIC_OWNER_KEY = 'globalMusicOwnerTabId';
const MUSIC_TIME_KEY = 'globalMusicCurrentTime';
const MUSIC_USER_PREFERENCE = 'globalMusicUserPreference';
const MUSIC_FORCE_PAUSE_EVENT = 'global-music-force-pause';
interface ChildComponentProps {
    gameSvcCd: string | undefined;
    gameMainPageData: any;
    onFixedChange?: (fixed: boolean) => void;
    mntnData?: any;
    tstrData?: any;
}

const GameLandingHdrUi: React.FC<ChildComponentProps> = ({ gameSvcCd, gameMainPageData, onFixedChange, mntnData, tstrData }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [gameSvcCdState, setGameSvcCdState] = useState(gameSvcCd);
    const { isLoading, error, data: langData }: any = UseLangLstQuery();
    const [showLaunchModal, setShowLaunchModal] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [gameMainPageInfoState, setGameMainPageInfoState] = useState<any>();
    const headerRef = useRef<HTMLDivElement>(null);
    const [isFixed, setIsFixed] = useState(false);
    const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isImgGlitch, setIsImgGlitch] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    
    // 로그인 상태
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    const firstLetter = loginInfoState?.loginId?.charAt(0).toUpperCase() || '';
    
    // 스프라이트 애니메이션 관련
    const btnRef = useRef<HTMLButtonElement>(null);
    const frameRef = useRef(0);
    const animateRef = useRef<number>();
    
 const SPRITE_CONFIG = {
            introStart: 1,         // 인트로 시작 프레임 (1부터 시작)
            introEnd: 61,          // 인트로 끝 프레임
            loopStart: 62,         // 루프 시작 프레임
            loopEnd: 161,           // 루프 끝 프레임
            outroStart: 162,        // 아웃트로(마우스 아웃) 시작 프레임
            outroEnd: 180,          // 아웃트로 끝 프레임
            frameHeight:60,      // 각 프레임 높이 (px)
            fps: 30,               // 초당 프레임 수 (frames per second)
            buttonWidth: "max-content",      // 버튼 너비 (px)
            buttonHeight: 60      // 버튼 높이 (px)
        };
    
    const frameInterval = 1000 / SPRITE_CONFIG.fps;
    const isIntroPlayed = useRef(false);
    const isMouseOver = useRef(false);

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };

    const stopBackgroundMusic = () => {
        localStorage.setItem(MUSIC_USER_PREFERENCE, 'pause');

        const globalMusicAudio = document.querySelector('.music-player audio') as HTMLAudioElement | null;
        if (globalMusicAudio) {
            localStorage.setItem(MUSIC_TIME_KEY, `${globalMusicAudio.currentTime || 0}`);
            globalMusicAudio.pause();
        }

        localStorage.removeItem(MUSIC_OWNER_KEY);
        window.dispatchEvent(new Event(MUSIC_FORCE_PAUSE_EVENT));
    };

    useEffect(() => {
        const handleScroll = () => {
            const isMobile = window.innerWidth <= 1024;
            // 모바일: 스크롤 즉시 fixed, PC: 50px 이상 스크롤 시 fixed
            const scrollThreshold = isMobile ? 0 : 50;
            setIsFixed(window.scrollY > scrollThreshold);
        };
        
        // 초기 실행
        handleScroll();
        
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (onFixedChange) onFixedChange(isFixed);
    }, [isFixed, onFixedChange]);
    useEffect(()=>{
        setGameMainPageInfoState(gameMainPageData);
    },[gameMainPageData])
    // 모바일 메뉴 열릴 때 body 스크롤 막기 (iOS Safari 대응)
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }
        return () => {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        };
    }, [isMobileMenuOpen]);
    
    // 스프라이트 애니메이션
    useEffect(() => {
        frameRef.current = SPRITE_CONFIG.introStart;
        isIntroPlayed.current = false;
        isMouseOver.current = false;
        
        const btnMove = () => {
            // 인트로 재생 중
            if (!isIntroPlayed.current) {
                // 호버 상태가 아니면 인트로 진행 안 함 (첫 프레임 유지)
                if (!isMouseOver.current) {
                    if (btnRef.current) {
                        btnRef.current.style.backgroundPosition = `0px -${(SPRITE_CONFIG.introStart - 1) * SPRITE_CONFIG.frameHeight}px`;
                    }
                    return;
                }
                
                frameRef.current++;
                if (frameRef.current > SPRITE_CONFIG.introEnd) {
                    isIntroPlayed.current = true;
                    frameRef.current = SPRITE_CONFIG.loopStart;
                }
            } 
            // 루프 재생 중
            else if (isMouseOver.current) {
                frameRef.current++;
                if (frameRef.current > SPRITE_CONFIG.loopEnd) {
                    frameRef.current = SPRITE_CONFIG.loopStart;
                }
            }
            // 아웃트로 재생 중 (마우스 아웃)
            else {
                frameRef.current++;
                if (frameRef.current > SPRITE_CONFIG.outroEnd) {
                    frameRef.current = SPRITE_CONFIG.introStart;
                    isIntroPlayed.current = false;
                }
            }
            
            if (btnRef.current) {
                btnRef.current.style.backgroundPosition = `0px -${(frameRef.current - 1) * SPRITE_CONFIG.frameHeight}px`;
            }
        };

        animateRef.current = window.setInterval(btnMove, frameInterval);

        return () => {
            if (animateRef.current) {
                clearInterval(animateRef.current);
            }
        };
    }, [gameMainPageData, frameInterval, SPRITE_CONFIG]);
    
    const handleBtnMouseEnter = () => {
        isMouseOver.current = true;
        setIsImgGlitch(true);
        
        // 글리치 애니메이션 트리거
        if (btnRef.current) {
            btnRef.current.style.animation = 'none';
            setTimeout(() => {
                if (btnRef.current) {
                    btnRef.current.style.animation = '';
                }
            }, 10);
        }
        
        if (!isIntroPlayed.current || frameRef.current >= SPRITE_CONFIG.outroStart) {
            frameRef.current = SPRITE_CONFIG.introStart;
            isIntroPlayed.current = false;
        }
    };
    
    const handleBtnMouseLeave = () => {
        isMouseOver.current = false;
        setIsImgGlitch(false);
        if (isIntroPlayed.current) {
            frameRef.current = SPRITE_CONFIG.outroStart;
        } else {
            frameRef.current = SPRITE_CONFIG.introStart;
        }
    };
    
    const logoutFunc = () => {
        MembNrmlLogoutApi().then(() => {
            window.location.href = "/";
        });
    };

    if (isLoading || !langData || !gameMainPageData) {
        return (
            <div className="gameSubHdrContainer">
                {/*<div className="loadingSpinner">로딩중...</div>*/}
                <div className="loadingSpinner">{langData?.COMM_MAIN_LOADING_00 || "로딩중..."}</div>
            </div>
        );
    }

    // 2단 메뉴 구조: 대메뉴+서브메뉴 (menu -> subMenuLst)
    const menuList = (gameMainPageData?.menu || []);
    
    // 서브메뉴가 있는 대메뉴만 필터링
    const menuListWithSubs = menuList.filter((m: any) => m.subMenuLst && m.subMenuLst.length > 0);
    
    
    const isMaintenance = mntnData ? 
        !!mntnData.find((item: any) => item.gameSvcCd?.toUpperCase() === gameSvcCdState?.toUpperCase() && item.isMntn === "Y")
        : false;
    
    

        const LnchStrtFunc = async (gameSvcCd:string) => {
            
            try {
                // 점검 확인 (MGP는 이미 GameMainLayout에서 확인됨)
                if (mntnData) {
                    const gameMntnInfo = mntnData?.find((item: any) => item.gameSvcCd?.toUpperCase() === gameSvcCd?.toUpperCase());
                    if(gameMntnInfo && gameMntnInfo.isMntn === "Y") {
                        // 테스터가 아니면 차단
                        if(tstrData?.yn !== "Y") {
                            openResultModal(langData?.COMM_MAIN_MNTN_MAIN_LBL_00 || "현재 점검 중입니다.");
                            return;
                        }
                    }
                }
                
                // 첫 번째 시도
                const firstResp = await LnchStrtApi(gameSvcCd,null);
                
                switch(firstResp.apiHdr.code) {
                    case "GAME0000":
                        // 바로 게임 실행
                        stopBackgroundMusic();
                        window.location.href = firstResp.apiBody.lnchScheme;
                        break;
                        
                    case "GAME3101":
                        // 게임 서비스 링크 설정 후 재시도
                        await GameSvcLinkApi(gameSvcCd);
                        
                        const retryResp = await LnchStrtApi(gameSvcCd,null);
                        if(retryResp.apiHdr.code === "GAME0000") {
                            stopBackgroundMusic();
                            window.location.href = retryResp.apiBody.lnchScheme;
                        } else {
                            openResultModal(`${retryResp.apiHdr.msg}`);
                        }
                        break;
                        
                    default:
                        openResultModal(`${firstResp.apiHdr.msg}`);
                        break;
                }
                // 모달 표시
                setShowLaunchModal(true);
            } catch (error) {
                // 인터셉터에서 reject한 ATHN2303는 이미 로그인 페이지로 이동했으므로 조용히 처리
                if ((error as any).code === "ATHN2303") {
                    return; // 아무것도 하지 않음
                }
                
                // 실제 네트워크 오류나 기타 예외 상황
                console.error('게임 실행 중 오류:', error);
                openResultModal(langData?.GAME_LAUNCH_ERROR || "게임 실행 중 오류가 발생했습니다.");
            }
        }

    return (
        <div 
            ref={headerRef} 
            className={`gameSubHdrContainer landingHdr${isFixed ? ' fixedHdr' : ''}`}
            onMouseEnter={() => setIsMegaMenuOpen(true)}
            onMouseLeave={() => setIsMegaMenuOpen(false)}
        >
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData && langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className="hdrLeft moCenter">
                <Link 
                    to={"/gamepage?gameSvcCd=" + gameSvcCdState} 
                    className="homeBtn"
                    onClick={() => {
                        setIsMegaMenuOpen(false);
                        setIsMobileMenuOpen(false);
                    }}
                >
                    <img src={gameMainPageData?.gameSvcUiInfo?.gameLogoUrl} alt="" />
                </Link>
            </div>
            <div className="hdrLeft">
                <button 
                    className={`hamburgerBtn${isMobileMenuOpen ? ' active' : ''}`}
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="메뉴"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <ul className="mainMenu">
                    {menuList.length > 0 ? (
                        menuList.map((main: any, idx: number) => (
                            <li key={main.menuNm} className={`mainMenuItem${main.useYn === "N" ? " disabled" : ""}`}>
                                {main.blankYn === "Y" ? (
                                    <a
                                        href={main.useYn === "Y" ? main.url : undefined}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={main.useYn === "N" ? `disabled menu_${main.menuCd}` : `menu_${main.menuCd}`}
                                        tabIndex={main.useYn === "N" ? -1 : undefined}
                                        onClick={main.useYn === "N" ? (e) => e.preventDefault() : undefined}
                                        aria-disabled={main.useYn === "N" ? "true" : undefined}
                                    >
                                        {main.menuNm}
                                    </a>
                                ) : (
                                    <Link
                                        to={main.useYn === "Y" ? main.url : "#"}
                                        className={main.useYn === "N" ? `disabled menu_${main.menuCd}` : `menu_${main.menuCd}`}
                                        tabIndex={main.useYn === "N" ? -1 : undefined}
                                        onClick={(e) => {
                                            if (main.useYn === "N") {
                                                e.preventDefault();
                                            } else {
                                                setIsMegaMenuOpen(false);
                                            }
                                        }}
                                        aria-disabled={main.useYn === "N" ? "true" : undefined}
                                    >
                                        {main.menuNm}
                                    </Link>
                                )}
                            </li>
                        ))
                    ) : (
                        <li className="no-menu-message">
                            {/*<p>사용 가능한 메뉴가 없습니다.</p>*/}
                            <p>{langData && langData.COMM_MAIN_NO_MENU_00 || "사용 가능한 메뉴가 없습니다."}</p>
                        </li>
                    )}
                </ul>
            </div>
            <div className="hdrRight">
                {
                    loginInfoState&&loginInfoState.login == true ?
                        <div className='isLoginWrap desktopIsLogin'>
                         <div 
                            className='flexLoginLink'
                            onMouseEnter={() => setIsLoginModalOpen(true)}
                            onMouseLeave={() => setIsLoginModalOpen(false)}
                         >
                            {/* {loginInfoState.ntfyMsgCnt != 0 ? 
                                <div className='loginLink'>
                                    <Link to={"/MyPage/NtfyMsgLst"} className='NtfyMsgIconWrap'>
                                        <div className="loginInfoCircle landingLoginCircle">
                                            <h1>{firstLetter}</h1>
                                        </div>
                                        <div className='ntfyMstCnt'>
                                            {
                                                loginInfoState.ntfyMsgCnt > 9 ?
                                                <p>9+</p>
                                                :
                                                <p>{loginInfoState.ntfyMsgCnt}</p>
                                            }
                                        </div>
                                    </Link>
                                </div>
                                : ""
                            } */}
                            <div className='loginLink '>
                                <Link to={"/MyPage"}>
                                 {loginInfoState.provider !=="MGP" ?
                                        <div className={`ssoLoginInfoCircle ${loginInfoState.provider}Icon`}>
                                            <img src={loginInfoState.ssoImgPUrl} alt="" />
                                        </div>
                                        :
                                        <div className="loginInfoCircle landingLoginCircle">
                                                <h1>{firstLetter}</h1>
                                        </div>
                                    }
                                </Link>
                            </div>
                        </div>
                        {/* <div className='loginLink'>
                            <button onClick={()=> logoutFunc()}>
                                <p>
                                    {langData&&langData.COMM_MAIN_LOGOUT_MAIN_BTN_00}
                                </p>
                            </button>
                        </div> */}
                        <div 
                            className={`loginInfoMdal${isLoginModalOpen ? ' open' : ''}`}
                            onMouseEnter={() => setIsLoginModalOpen(true)}
                            onMouseLeave={() => setIsLoginModalOpen(false)}
                        >
                            <div className="loginIdInfoWrap">
                               {loginInfoState.provider !=="MGP" ?
                                    <div className={`ssoLoginInfoCircle ${loginInfoState.provider}Icon`}>
                                        <img src={loginInfoState.ssoImgPUrl} alt="" />
                                    </div>
                                    :
                                    <div className="loginInfoCircle landingLoginCircle">
                                            <h1>{firstLetter}</h1>
                                    </div>
                                }
                                {loginInfoState.loginId && <p>{loginInfoState.loginId}</p>}
                            </div>
                            <div className="nicknameInfoWrap">
                                <p>{loginInfoState.nickname}<span>#{loginInfoState.rcmnCd}</span></p>
                            </div>
                            <div className="mnyInfoWrap">
                                <p>
                                    My {loginInfoState.gameMnyNm}
                                    <span>{loginInfoState.totMny}</span>
                                </p>
                                {/* <Link to={'/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=KRBBO'} className="mnyDpstBtn">
                                    {langData&&langData.GLB_HDR_MNY_DPST_BTN_00}
                                </Link> */}
                            </div>
                            <div className="LogoutWrap">
                                <button onClick={()=> logoutFunc()} className="logoutBtn">
                                    <p>
                                        Log Out
                                    </p>
                                </button>
                                <Link to={'/Mypage'}>
                                    <p>My page</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                    :<div className='isLoginWrap desktopIsLogin'>
                        {/* <div className='loginLink'>
                            <Link to={`/MembJoin?referrer=${encodeURIComponent(location.pathname + location.search)}`}>
                                <p>{langData&&langData.GLB_HDR_MEMB_JOIN_BTN_00}</p>
                            </Link>
                        </div> */}
                        <div className='loginLink'>
                            <Link to={`/Login?referrer=${encodeURIComponent(location.pathname + location.search)}`}>
                                <p>{langData&&langData.GLB_HDR_LOGIN_BTN_00}</p>
                            </Link>
                        </div>
                            {/* <button className="modalTestBtn" onClick={() => setShowLoginModal(true)} style={{marginLeft:8}}>LoginModal</button> */}
                    </div>
                }
                {/* 모바일 로그인/로그아웃 버튼 */}
                <div className="mobileLoginBtns">
                    {loginInfoState && loginInfoState.login == true ? (
                            <div className={`'isLoginWrap desktopIsLogin moIsLogin' `}>
                                <div 
                                    className='flexLoginLink'
                                    onMouseEnter={!isMobile ? () => setIsLoginModalOpen(true) : undefined}
                                    onMouseLeave={!isMobile ? () => setIsLoginModalOpen(false) : undefined}
                                    onClick={isMobile ? () => setIsLoginModalOpen(v => !v) : undefined}
                                >
                                    <div className='loginLink '>
                                        {loginInfoState.provider !=="MGP" ?
                                            <div className={`ssoLoginInfoCircle ${loginInfoState.provider}Icon`}>
                                                <img src={loginInfoState.ssoImgPUrl} alt="" />
                                            </div>
                                            :
                                            <div className="loginInfoCircle">
                                                    <h1>{firstLetter}</h1>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div 
                                    className={`loginInfoMdal${isLoginModalOpen ? ' open' : ''}`}
                                    onMouseEnter={!isMobile ? () => setIsLoginModalOpen(true) : undefined}
                                    onMouseLeave={!isMobile ? () => setIsLoginModalOpen(false) : undefined}
                                    onClick={isMobile ? () => setIsLoginModalOpen(v => !v) : undefined}
                                >
                                    <div className="loginIdInfoWrap">
                                            {loginInfoState.provider !=="MGP" ?
                                                <div className={`ssoLoginInfoCircle ${loginInfoState.provider}Icon`}>
                                                    <img src={loginInfoState.ssoImgPUrl} alt="" />
                                                </div>
                                                :
                                                <div className="loginInfoCircle">
                                                        <h1>{firstLetter}</h1>
                                                </div>
                                            }
                                        {loginInfoState.loginId && <p>{loginInfoState.loginId}</p>}
                                    </div>
                                    <div className="nicknameInfoWrap">
                                        <p>{loginInfoState.nickname}<span>#{loginInfoState.rcmnCd}</span></p>
                                    </div>
                                    <div className="mnyInfoWrap">
                                        <p>
                                            My {loginInfoState.gameMnyNm}
                                            <span> {loginInfoState.totMny}</span>
                                        </p>
                                         {/* <Link to={'/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=KRBBO'} className="mnyDpstBtn">
                                            {langData&&langData.GLB_HDR_MNY_DPST_BTN_00}
                                        </Link>  */}
                                    </div>
                                    <div className="LogoutWrap">
                                        <button onClick={()=> logoutFunc()} className="logoutBtn">
                                            <p>
                                                Log Out
                                            </p>
                                        </button>
                                        <Link to={'/Mypage'}>
                                            <p>My page</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                ) : (
                    <div className='isLoginWrap desktopIsLogin moIsLogin'>
                        <div className='loginLink'>
                            <Link to={`/Login?referrer=${encodeURIComponent(location.pathname + location.search)}`}>
                                <p>{langData&&langData.GLB_HDR_LOGIN_BTN_00}</p>
                            </Link>
                        </div>
                        {/* <button className="modalTestBtn" onClick={() => setShowLoginModal(true)} style={{marginLeft:8}}>LoginModal</button> */}
                    </div>
                )}
                </div>
            </div>
            {/* 모든 대메뉴의 서브메뉴를 한 번에 보여주는 메가메뉴 - 대메뉴와 라인 맞춤 */}
            {menuListWithSubs.length > 0 && isMegaMenuOpen && (
                <div className="megaMenu">
                    <div className="megaMenuInner">
                        {menuList.map((main: any, idx: number) => (
                            <div 
                                key={main.menuNm} 
                                className="megaMenuCol" 
                                data-menu={main.menuNm}
                                onMouseEnter={() => {
                                    const menuItems = document.querySelectorAll('.mainMenuItem');
                                    menuItems.forEach((item, i) => {
                                        if (i === idx) {
                                            item.classList.add('hovered');
                                        }
                                    });
                                }}
                                onMouseLeave={() => {
                                    const menuItems = document.querySelectorAll('.mainMenuItem');
                                    menuItems.forEach(item => item.classList.remove('hovered'));
                                }}
                            >
                                {main.subMenuLst && main.subMenuLst.length > 0 ? (
                                    <ul>
                                        {main.subMenuLst.map((sub: any) => (
                                            <li key={sub.menuNm} className={sub.useYn === "N" ? "disabled" : undefined}>
                                                {sub.blankYn === "Y" ? (
                                                    <a
                                                        href={sub.useYn === "Y" ? sub.url : undefined}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={sub.useYn === "N" ? "disabled" : undefined}
                                                        tabIndex={sub.useYn === "N" ? -1 : undefined}
                                                        onClick={sub.useYn === "N" ? (e) => e.preventDefault() : undefined}
                                                        aria-disabled={sub.useYn === "N" ? "true" : undefined}
                                                    >
                                                        {sub.menuNm}
                                                    </a>
                                                ) : (
                                                    <Link
                                                        to={sub.useYn === "Y" ? sub.url : "#"}
                                                        className={sub.useYn === "N" ? "disabled" : undefined}
                                                        tabIndex={sub.useYn === "N" ? -1 : undefined}
                                                        onClick={(e) => {
                                                            if (sub.useYn === "N") {
                                                                e.preventDefault();
                                                            } else {
                                                                setIsMegaMenuOpen(false);
                                                                // hovered 클래스 제거
                                                                const menuItems = document.querySelectorAll('.mainMenuItem');
                                                                menuItems.forEach(item => item.classList.remove('hovered'));
                                                            }
                                                        }}
                                                        aria-disabled={sub.useYn === "N" ? "true" : undefined}
                                                    >
                                                        {sub.menuNm}
                                                    </Link>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                ) : <div className="noSubMenu"></div>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {/* 모바일 메뉴 */}
            {isMobileMenuOpen && createPortal(
                <div className="mobileMenu">
                    <div className="mobileMenuInner">
                        {menuList.map((main: any) => (
                            <div key={main.menuNm} className={`mobileMenuGroup${main.useYn === "N" ? " disabled" : ""}`}>
                                <div className="mobileMenuTitle">
                                    {main.blankYn === "Y" ? (
                                        <a 
                                            href={main.useYn === "Y" ? main.url : undefined} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className={main.useYn === "N" ? "disabled" : undefined}
                                            onClick={(e) => {
                                                if (main.useYn === "N") {
                                                    e.preventDefault();
                                                } else {
                                                    setIsMobileMenuOpen(false);
                                                }
                                            }}
                                            tabIndex={main.useYn === "N" ? -1 : undefined}
                                            aria-disabled={main.useYn === "N" ? "true" : undefined}
                                        >
                                            {main.menuNm}
                                        </a>
                                    ) : (
                                        <Link 
                                            to={main.useYn === "Y" ? main.url : "#"} 
                                            className={main.useYn === "N" ? "disabled" : undefined}
                                            onClick={(e) => {
                                                if (main.useYn === "N") {
                                                    e.preventDefault();
                                                } else {
                                                    setIsMobileMenuOpen(false);
                                                }
                                            }}
                                            tabIndex={main.useYn === "N" ? -1 : undefined}
                                            aria-disabled={main.useYn === "N" ? "true" : undefined}
                                        >
                                            {main.menuNm}
                                        </Link>
                                    )}
                                </div>
                                {main.subMenuLst && main.subMenuLst.length > 0 && (
                                    <ul className="mobileSubMenu">
                                        {main.subMenuLst
                                            .filter((sub: any) => sub.menuNm !== "WEB SHOP")
                                            .map((sub: any) => (
                                                <li key={sub.menuNm} className={sub.useYn === "N" ? "disabled" : undefined}>
                                                    {sub.blankYn === "Y" ? (
                                                        <a 
                                                            href={sub.useYn === "Y" ? sub.url : undefined} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer" 
                                                            className={sub.useYn === "N" ? "disabled" : undefined}
                                                            onClick={(e) => {
                                                                if (sub.useYn === "N") {
                                                                    e.preventDefault();
                                                                } else {
                                                                    setIsMobileMenuOpen(false);
                                                                }
                                                            }}
                                                            tabIndex={sub.useYn === "N" ? -1 : undefined}
                                                            aria-disabled={sub.useYn === "N" ? "true" : undefined}
                                                        >
                                                            {sub.menuNm}
                                                        </a>
                                                    ) : (
                                                        <Link 
                                                            to={sub.useYn === "Y" ? sub.url : "#"} 
                                                            className={sub.useYn === "N" ? "disabled" : undefined}
                                                            onClick={(e) => {
                                                                if (sub.useYn === "N") {
                                                                    e.preventDefault();
                                                                } else {
                                                                    setIsMobileMenuOpen(false);
                                                                }
                                                            }}
                                                            tabIndex={sub.useYn === "N" ? -1 : undefined}
                                                            aria-disabled={sub.useYn === "N" ? "true" : undefined}
                                                        >
                                                            {sub.menuNm}
                                                        </Link>
                                                    )}
                                                </li>
                                            ))}
                                    </ul>
                                )}
                            </div>
                        ))}
                    </div>
                </div>,
                document.body
            )}
             {showLaunchModal && (
            <GameLnchMdalUi 
                gameMainPageInfoState={gameMainPageInfoState} 
                langData={langData}
                onClose={() => setShowLaunchModal(false)}
            />
        )}
        {showLoginModal && (
            <LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} referrer={encodeURIComponent(location.pathname + location.search)} />
        )}
        </div>
        
    );
}

export default GameLandingHdrUi;